import React from 'react';
import { Star } from 'lucide-react';

const PlansHeroSection = () => {
  return (
    <div 
      className="min-h-[calc(100vh-80px)] flex items-center relative"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&h=1080&fit=crop&crop=center')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Overlay con blur */}
      <div className="absolute inset-0 bg-black/20 backdrop-blur-sm"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-8 md:gap-12 items-start">
          
          {/* Contenido informativo */}
          <div className="text-white space-y-6 md:space-y-8 text-center lg:text-left">
            {/* Título principal */}
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-center lg:text-left">
              Find the Right <span className="text-red-500">Azucarai Marketing Plan</span> for Your Business.
            </h1>
            
            {/* Párrafo descriptivo */}
            <p className="text-base sm:text-lg text-gray-200 leading-relaxed text-center lg:text-left">
              At Azucarai, we understand that every business is unique. That's why we take the time to assess your goals, 
              industry, and target audience to craft a tailored marketing strategy that maximizes your visibility and drives results. 
              Our comprehensive solutions include SEO, social media management, and local search marketing, all designed to help 
              your business thrive in today's competitive landscape. We provide diverse marketing plans to meet your specific 
              needs and budget.
            </p>
            
            {/* Testimonial */}
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 md:p-6 border border-white/20">
              <div className="flex items-start space-x-3 md:space-x-4">
                <div className="text-4xl md:text-6xl text-red-500 font-bold">"</div>
                <div className="flex-1">
                  <div className="flex flex-col sm:flex-row sm:items-center space-y-1 sm:space-y-0 sm:space-x-2 mb-3">
                    <span className="font-semibold text-white">Lawrence K.</span>
                    <div className="flex items-center space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className="w-3 h-3 md:w-4 md:h-4 text-yellow-400 fill-current" />
                      ))}
                    </div>
                  </div>
                  <p className="text-gray-200 italic text-sm md:text-base text-center lg:text-left">
                    "Azucarai has been hugely beneficial for my business! Thanks to them, my business comes up #1 on Google 
                    searches and customers have been flocking in. Highly recommend them!!"
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Formulario */}
          <div className="bg-white rounded-lg shadow-2xl p-6 md:p-8 w-full">
            <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6 text-center lg:text-left">Get a Custom Marketing Plan</h2>
            
            <form className="space-y-4 md:space-y-6">
              {/* Campo Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                <input
                  type="text"
                  placeholder="Name"
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none text-base"
                />
              </div>

              {/* Campo Email */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                <input
                  type="email"
                  placeholder="Email"
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none text-base"
                  required
                />
              </div>

              {/* Campo Phone */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Phone *</label>
                <input
                  type="tel"
                  placeholder="Phone"
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none text-base"
                  required
                />
              </div>

              {/* Campo Company Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Company Name *</label>
                <input
                  type="text"
                  placeholder="Company Name"
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none text-base"
                  required
                />
              </div>

              {/* Campo Website */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Website</label>
                <input
                  type="url"
                  placeholder="Website"
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none text-base"
                />
              </div>

              {/* Checkbox de consentimiento */}
              <div className="space-y-3 md:space-y-4">
                <label className="flex items-start space-x-3">
                  <input
                    type="checkbox"
                    className="mt-1 w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
                    required
                  />
                  <span className="text-xs md:text-sm text-gray-600">
                    By clicking 'Submit,' I agree to receive emails, text messages, and phone calls regarding registration 
                    notifications, and status updates. I also agree to the{' '}
                    <a href="#" className="text-red-600 hover:underline">Terms of Use</a> and{' '}
                    <a href="#" className="text-red-600 hover:underline">Privacy Policy</a>. Reply STOP to opt out and 
                    HELP for assistance. Message & data rates may apply. Message frequency varies.
                  </span>
                </label>
              </div>

              {/* Captcha */}
              <div className="space-y-2">
                <h4 className="text-sm font-medium text-gray-700">Captcha</h4>
                <label className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    className="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
                    required
                  />
                  <span className="text-sm text-gray-600">I'm not a robot</span>
                  <div className="text-xs text-gray-500">reCAPTCHA</div>
                </label>
              </div>

              {/* Botón Submit */}
              <button
                type="submit"
                className="w-full bg-red-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-red-700 transition-colors text-base"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlansHeroSection;
